import { produce } from 'immer'
import { includes, reject } from 'lodash'
import { CustomLabelPrintData } from '../apis/customLabelPrint.api'
import { TableHorizontalData } from '../components/TableHorizontal'

export default {
  tableHorizontalData (
    customLabelPrints: CustomLabelPrintData[]
  ): TableHorizontalData<CustomLabelPrintData>[] {
    return customLabelPrints
  },

  deleteMany (customLabelPrints: TableHorizontalData<CustomLabelPrintData>[], ids: number[]) {
    return produce(customLabelPrints,
      customLabelPrints => {
        return reject(customLabelPrints, customLabelPrint => {
          return includes(ids, customLabelPrint.id)
        })
      }
    )
  }
}
